import Icon from 'vue-awesome/components/Icon'

Icon.register({
  mobile_off_rounded: {
    paths: [
      {
        d: 'M17 16.44L3.61 3.05A.996.996 0 102.2 4.46L5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75L20 22.27a.996.996 0 101.41-1.41L19 18.44l-2-2zM7 19V9.27L16.73 19H7zM17 5v8.61l2 2V3c0-1.1-.9-2-2-2H7c-.71 0-1.33.37-1.68.93L8.39 5H17z'
      }
    ],
    width: '24',
    height: '24'
  }
})
